import { ClassHelper, Label } from "components/lib";
import CurrencyInput from "react-currency-input-field";
import Style from "./input.module.scss";

export function MoneyInput(props) {
  const MoneyStyle = ClassHelper(Style, {
    textbox: true,
    className: props.className,
    error: props.valid === false,
    success: props.valid === true,
    warning: props.warning,
  });

  return (
    <div className={Style.input}>
      {props.label && (
        <Label text={props.label} required={props.required} for={props.name} />
      )}

      <CurrencyInput
        id={props.name}
        name={props.name}
        defaultValue={1000}
        decimalsLimit={2}
        value={props.value || ""}
        placeholder="$"
        prefix="$"
        decimalSeparator="."
        groupSeparator=","
        onValueChange={(value, name) =>
          props.onChange?.(name, value, undefined)
        }
        className={MoneyStyle}
        readOnly={props.readonly}
      />
    </div>
  );
}
